import type { AxiosResponse } from 'axios';
import { HttpForbiddenException } from './exceptions/forbidden-exception';
import { HttpNotFoundException } from './exceptions/not-found-exception';

interface BaseResponse {
  error?: {
    code: string;
    description: string;
  };
}

interface ExceptionMap {
  [status: number]:
    | typeof HttpNotFoundException
    | typeof HttpForbiddenException;
}

const exception: ExceptionMap = {
  404: HttpNotFoundException,
  403: HttpForbiddenException,
};

export const exceptionHandler = <T extends BaseResponse>(
  response: AxiosResponse<T>
) => {
  const messages = String(response.data.error?.description);

  if (response.status in exception) {
    return new exception[response.status](messages);
  }

  return new Error(messages);
};
